import ErrorModel from '../system/error';

export default class BaseResponse {
    public error: ErrorModel;
    public servertime: number;
    public messages: number;
}


// WEBPACK FOOTER //
// ./src/app/models/kartinatv-responses/base.response.ts